module.exports = __webpack_public_path__ + "img/FrogInPot.9fb8276c.png";